export function stagedPagesFromFiles(files: Array<{ numberOfPages?: number | null }> | undefined): number {
  return (files ?? []).reduce((total, file) => total + (file.numberOfPages ?? 0), 0);
}
